module.exports = __webpack_public_path__ + "img/a50a190.jpg";